
  export const DEFAULT_AVATAR_WHITE =
  "https://firebasestorage.googleapis.com/v0/b/reshub.appspot.com/o/simages%2Fno-avatar.png?alt=media&token=7c28f952-1160-479f-ac60-98945feb1e10";

  export const DEFAULT_AVATAR_WHITE_200x200 = 
  "https://firebasestorage.googleapis.com/v0/b/reshub.appspot.com/o/simages%2Fno-avatar_200x200.png?alt=media&token=7c28f952-1160-479f-ac60-98945feb1e10";

  export const DEFAULT_AVATAR_BLACK =
  "https://firebasestorage.googleapis.com/v0/b/reshub.appspot.com/o/familyHub%2Fno-avatar.png?alt=media&token=98138637-c21e-41da-aaad-584a67694a54";

